/** OD-026: 외부 폰트 의존성 0. Display 폰트 미도입. */
export const fontStacks = {
  sans: 'Pretendard, -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Hiragino Sans", "Noto Sans JP", "Segoe UI", Roboto, sans-serif',
  mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, monospace',
} as const;

export const typeScale = {
  "display/lg": { size: 32, line: 40, weight: 700, tracking: "-0.02em" },
  "display/md": { size: 28, line: 36, weight: 700, tracking: "-0.02em" },
  "title/lg":   { size: 22, line: 30, weight: 700, tracking: "-0.015em" },
  "title/md":   { size: 18, line: 26, weight: 600, tracking: "-0.01em" },
  "title/sm":   { size: 16, line: 24, weight: 600, tracking: "0" },
  "body/lg":    { size: 16, line: 26, weight: 400, tracking: "0" },
  "body/md":    { size: 14, line: 22, weight: 400, tracking: "0" },
  "body/sm":    { size: 13, line: 20, weight: 400, tracking: "0" },
  "label/md":   { size: 13, line: 18, weight: 600, tracking: "0.01em" },
  "label/sm":   { size: 11, line: 16, weight: 700, tracking: "0.04em" },
  "caption":    { size: 11, line: 16, weight: 400, tracking: "0" },
} as const;
export type TypeToken = keyof typeof typeScale;
